import { DoohReport } from '@/components/doohReport';
import { useDoohReportNavigation } from '@/components/doohReport/common/hooks/useDoohReportNavigation';
import { useGlobalStore } from '@/store/global';
import { getUser } from '@/store/global/user/selectors.ts';

export default function DoohReportPage() {
  const { lineItemId } = useDoohReportNavigation();
  const user = useGlobalStore(getUser);

  return <DoohReport lineItemId={lineItemId} userId={user.toJSON().id!} />;
}
